import React from 'react';

import {PreviousMeetingsWidgetView} from "./previous-meetings-widget.view";
import {PreviousMeetingsWidgetController} from "../previous-meetings-widget.controller";
import {PreviousMeetingsWidgetProps} from "../models/previous-meetings-widget.props";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {PreviousMeetingsWidgetPlaceholder} from "./placeholders/previous-meetings-widget.placeholder";
import {WidgetWrapper} from "../../../core/components/misc/widget-wrapper/widget-wrapper";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../core/consts";
import {Loader} from "../../../core/components/loading/loader";

export const PreviousMeetingsWidgetComponent = ({controller, isFullView}: PreviousMeetingsWidgetProps) => {
  const {state} = controller;
  const {terms, fetchingState, componentState} = state;

  const loaderProps = {
    when: fetchingState === FETCHING_STATES.fetching || componentState === COMPONENT_STATES.loading,
    Component: PreviousMeetingsWidgetPlaceholder,
    componentProps: {isFullView}
  }

  const widgetProps = {
    controller,
    title: isFullView ? terms.WEB_GC_HEAD_TO_HEAD : null,
  };

  const previewProps = {
    controller,
    isFullView
  }

  return (
    <Loader {...loaderProps}>
      {
        isFullView ? <WidgetWrapper {...widgetProps}>
          <PreviousMeetingsWidgetView {...previewProps}/>
        </WidgetWrapper> : <PreviousMeetingsWidgetView {...previewProps}/>
      }
    </Loader>
  )
};

const settings: ComposeSettings = {
  component: PreviousMeetingsWidgetComponent,
  propsType: PreviousMeetingsWidgetProps,
  controllerType: PreviousMeetingsWidgetController,

  createModule: true,
  observe: true,
};

export default Compose(settings);
